"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivitySessionApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class ActivitySessionApi extends runtime.BaseAPI {
    /**
     * 活動場次時段設定-新增
     */
    activitySessionCreatePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['asNo'] != null) {
                queryParameters['AsNo'] = requestParameters['asNo'];
            }
            if (requestParameters['asOrgID'] != null) {
                queryParameters['AsOrgID'] = requestParameters['asOrgID'];
            }
            if (requestParameters['asGroup'] != null) {
                queryParameters['AsGroup'] = requestParameters['asGroup'];
            }
            if (requestParameters['asHourS'] != null) {
                queryParameters['AsHourS'] = requestParameters['asHourS'];
            }
            if (requestParameters['aSMinuteS'] != null) {
                queryParameters['ASMinuteS'] = requestParameters['aSMinuteS'];
            }
            if (requestParameters['aSHourE'] != null) {
                queryParameters['ASHourE'] = requestParameters['aSHourE'];
            }
            if (requestParameters['aSMinuteE'] != null) {
                queryParameters['ASMinuteE'] = requestParameters['aSMinuteE'];
            }
            if (requestParameters['asActive'] != null) {
                queryParameters['AsActive'] = requestParameters['asActive'];
            }
            if (requestParameters['asUpDate'] != null) {
                queryParameters['AsUpDate'] = requestParameters['asUpDate'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['picFile'] != null) {
                formParams.append('PicFile', requestParameters['picFile']);
            }
            const response = yield this.request({
                path: `/ActivitySession/Create`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 活動場次時段設定-新增
     */
    activitySessionCreatePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.activitySessionCreatePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 活動設定-刪除
     */
    activitySessionDeleteDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ActivitySession/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 活動設定-刪除
     */
    activitySessionDeleteDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.activitySessionDeleteDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activitySessionDeleteImageDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['guid'] != null) {
                queryParameters['guid'] = requestParameters['guid'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ActivitySession/DeleteImage`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    activitySessionDeleteImageDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.activitySessionDeleteImageDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 活動場次時段設定-編輯
     */
    activitySessionEditPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['asNo'] != null) {
                queryParameters['AsNo'] = requestParameters['asNo'];
            }
            if (requestParameters['asOrgID'] != null) {
                queryParameters['AsOrgID'] = requestParameters['asOrgID'];
            }
            if (requestParameters['asGroup'] != null) {
                queryParameters['AsGroup'] = requestParameters['asGroup'];
            }
            if (requestParameters['asHourS'] != null) {
                queryParameters['AsHourS'] = requestParameters['asHourS'];
            }
            if (requestParameters['aSMinuteS'] != null) {
                queryParameters['ASMinuteS'] = requestParameters['aSMinuteS'];
            }
            if (requestParameters['aSHourE'] != null) {
                queryParameters['ASHourE'] = requestParameters['aSHourE'];
            }
            if (requestParameters['aSMinuteE'] != null) {
                queryParameters['ASMinuteE'] = requestParameters['aSMinuteE'];
            }
            if (requestParameters['asActive'] != null) {
                queryParameters['AsActive'] = requestParameters['asActive'];
            }
            if (requestParameters['asUpDate'] != null) {
                queryParameters['AsUpDate'] = requestParameters['asUpDate'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['picFile'] != null) {
                formParams.append('PicFile', requestParameters['picFile']);
            }
            const response = yield this.request({
                path: `/ActivitySession/Edit`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 活動場次時段設定-編輯
     */
    activitySessionEditPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.activitySessionEditPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activitySessionGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ActivitySession/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    activitySessionGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activitySessionGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 活動場次時段設定-編輯頁查詢
     */
    activitySessionGetByIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ActivitySession/GetById`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 活動場次時段設定-編輯頁查詢
     */
    activitySessionGetByIdGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.activitySessionGetByIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 活動場次時段設定-分頁查詢
     */
    activitySessionGetPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ActivitySession/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ActivitySessionDataViewModelToJSON)(requestParameters['activitySessionDataViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 活動場次時段設定-分頁查詢
     */
    activitySessionGetPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.activitySessionGetPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.ActivitySessionApi = ActivitySessionApi;
